import React from "react";
import { Grid } from "@material-ui/core";

import { useStyles } from "./styles";

export default function KooeeBanner() {
  const classes = useStyles();
  return (
    <Grid container>
      <picture className={classes.picture}>
        <source media="(min-width: 1024px)" srcSet={require("../../../resources/images/headerdesktop.png")} />
        <source media="(max-width: 768px)" srcSet={require("../../../resources/images/headertablet.png")} />
        <source media="(min-width: 768px) and (max-width: 1024px)" srcSet={require("../../../resources/images/headertablet.png")} />
        <img src={require("../../../resources/images/placeholder.png")} className={classes.banner} alt="" />
      </picture>
    </Grid>
  );
}
